import { utils } from "pixi.js";
import { app } from "./app";

/**
 * Env names: "local" | "demo"
 */
class Env {
    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;

        switch (this.name) {
            default:
            case "local":
                this.appOptionOverrides = {};
                this.parseUrlParams();
                this.addCheats();
                break;

            case "demo":
                break;
        }
    }

    constructor() {
        // Url Params
        this.params = {};

        // Audio enabled.
        this.audio = utils.isMobile.any && !this.supportsWebAudio();

        // Motion enabled.
        this.motion = true;

        // Environment name
        this.name = "local";
    }

    /**
     */
    supportsWebAudio() {
        return (
            typeof window.AudioContext !== "undefined" ||
            typeof window.webkitAudioContext !== "undefined"
        );
    }

    /**
     * Url params:
     *
     * screen=<string>
     * Launch the game at a given screen.
     *
     * res=<string>
     * Launch the game with a given resolution.
     *
     * e.g. ?debug=true;screen=splash;res=0.75
     *
     */
    parseUrlParams() {
        const search = window.location.search.substr(1).split(";");
        for (let i = 0; i < search.length; i++) {
            const param = search[i].split("=");
            this.params[param[0]] = param.length > 0 ? param[1] : true;
        }
    }

    /**
     */
    disableUrlParams() {
        for (const key in this.params) {
            if (this.params.hasOwnProperty(key)) {
                this.params[key] = undefined;
            }
        }
    }

    /**
     */
    addCheats() {
        // window.addEventListener("keydown", this.onKeyDown.bind(this));
    }

    removeCheats() {
        // window.removeEventListener("keydown", this.onKeyDown.bind(this));
    }

    onKeyDown(e) {
        // Fast forward.
        if (e.code === "KeyQ") {
            if (createjs.Tween.timeScale !== 10) createjs.Tween.timeScale = 10;
            else createjs.Tween.timeScale = 1;
        }

        // Mute sfx.
        if (e.code === "KeyI") {
            const groupName = "sfx";
            app.sound.groups[groupName].muted = !app.sound.groups[groupName].muted;
            console.log("mute", groupName, app.sound.groups[groupName].muted);
        }
        // Mute music.
        if (e.code === "KeyO") {
            const groupName = "vo";
            app.sound.groups[groupName].muted = !app.sound.groups[groupName].muted;
            app.sound.groups.voui.muted = !app.sound.groups.voui.muted;
            console.log("mute", groupName, app.sound.groups[groupName].muted);
        }
        // Mute music.
        if (e.code === "KeyP") {
            const groupName = "music";
            app.sound.groups[groupName].muted = !app.sound.groups[groupName].muted;
            console.log("mute", groupName, app.sound.groups[groupName].muted);
        }
        // Pause sfx.
        if (e.code === "KeyJ") {
            const groupName = "sfx";
            app.sound.groups[groupName].paused = !app.sound.groups[groupName].paused;
            console.log("pause", groupName, app.sound.groups[groupName].paused);
        }
        // Pause vo.
        if (e.code === "KeyK") {
            const groupName = "vo";
            app.sound.groups[groupName].paused = !app.sound.groups[groupName].paused;
            console.log("pause", groupName, app.sound.groups[groupName].paused);
        }
        // Pause music.
        if (e.code === "KeyL") {
            const groupName = "music";
            app.sound.groups[groupName].paused = !app.sound.groups[groupName].paused;
            console.log("pause", groupName, app.sound.groups[groupName].paused);
        }
    }
}

export const env = new Env();
